import {
  InvalidateQueryFilters,
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { MAG_HOME_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { ErrorDTO } from "interface";

type DeleteFromArticleLineParams = {
  magHomePageArticleLineId: number;
  articleId: number;
};
type QueryOptionsWithoutMutationFn = Omit<
  UseMutationOptions<
    unknown,
    AxiosError<ErrorDTO>,
    DeleteFromArticleLineParams,
    unknown
  >,
  "mutationFn"
>;

export const useDeleteFromArticleLine = (
  options?: QueryOptionsWithoutMutationFn
) => {
  const queryClient = useQueryClient();

  return useMutation<
    unknown,
    AxiosError<ErrorDTO>,
    DeleteFromArticleLineParams
  >({
    retry: 0,
    ...options,
    mutationFn: async (params: DeleteFromArticleLineParams) => {
      const result = await instance.delete(
        `${MAG_HOME_END_POINTS.delete_article_line_article}`,
        {
          data: params,
        }
      );

      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([
        MAG_HOME_END_POINTS.article_line_articles_list,
      ] as InvalidateQueryFilters);
      toast.success(`مقاله با موفقیت از لاین حذف گردید`);
    },
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(`${e.response?.data?.Message || "خطا در حذف مقاله از لاین"}`);
    },
  });
};
